"use client";

import type { SagraListing } from "@/types/sagra";
import { EventCard } from "@/components/cards/EventCard";
import { sagraToEventCard } from "@/lib/card-mappers";
import { toSagraHref, toSagraEditionHref } from "@/lib/routes";
import { buildSlugEid } from "@/lib/route";

type CardSagraProps = {
  sagra: SagraListing;
  showProvince?: boolean;
  showMotherLink?: boolean;
};

export function CardSagra({ sagra, showProvince = true, showMotherLink = true }: CardSagraProps) {
  // Usa lo stesso mapper che già popola l'EventCard
  const mapped = sagraToEventCard(sagra, { showProvince, showMotherLink }) as any;

  // Estrai gli href e passa il resto alla card
  const { href: editionHref, motherHref, ...rest } = mapped;

  // Costruisci gli href usando i route builders
  const slugEid = buildSlugEid(sagra.slug, sagra.id);
  const madreHref = toSagraHref(slugEid);
  // Supporta anche year dal nearby-index.json
  const year = (sagra as any).year ?? sagra.currentYear;
  const editionHrefBuilt = year ? toSagraEditionHref(slugEid, year) : madreHref;

  return (
    <article className="cardSagra block group">
      {/* L'EventCard contiene già il suo <Link> interno, quindi non serve un wrapper esterno */}
      <EventCard {...rest} href={editionHrefBuilt} motherHref={motherHref} />
    </article>
  );
}
